$(document).ready(function() {
  var articleImg = $(".news-item-detail article").find(">img");
  var articleTitle = $(".news-item-detail article").find("header");
  var articleFooter = $(".news-item-detail article").find("footer");
  var articleUvod = $('.news-item-detail article span[style="text-decoration: underline;"]').closest('p')
  $('.news-item-detail article').prepend("<div class='text-header'><div class='right'><div class='top'></div></div></div>")
  $('.text-header').prepend(articleImg)
  $('.text-header .right').prepend(articleFooter)
  $('.text-header .right .top').prepend(articleUvod)
  $('.text-header .right .top').prepend(articleTitle)

  });